import {MainAccountConfig} from 'main/content/accounting/main/MainAccountConfig';
import {LedgerAccountConfig} from 'main/content/accounting/ledgerAccount/LedgerAccountConfig';
import {AccountCategoryConfig} from 'main/content/accounting/accountCategory/AccountCategoryConfig';
import {BankConfig} from 'main/content/accounting/bank/BankConfig';
import {CheckBookConfig} from 'main/content/accounting/checkBook/CheckBookConfig';
import {NormalPaymentConfig} from 'main/content/accounting/normalPayment/NormalPaymentConfig';
import {openningBalanceConfig} from 'main/content/accounting/openningBalance/openningBalanceConfig';
import {BillEntriesConfig} from 'main/content/accounting/billEntries/BillEntriesConfig';
import {InterAccTransferConfig} from 'main/content/accounting/interAccTransfer/InterAccTransferConfig';
import {JournalEntryConfig} from 'main/content/accounting/journalEntry/JournalEntryConfig';

import {BillPaymnetConfig} from 'main/content/accounting/billPayment/BillPaymnetConfig';
import {pettyCashConfig} from 'main/content/accounting/pettyCash/pettyCashConfig';
import {BankDepositConfig} from 'main/content/accounting/bankDeposit/BankDepositConfig';
import {BankReconsilationConfig} from 'main/content/accounting/bankReconsilation/BankReconsilationConfig';
import {cashTransactionConfig} from 'main/content/accounting/cashTransaction/cashTransactionConfig';

export const accountConfigs = [
    MainAccountConfig,
    AccountCategoryConfig,
    BankConfig,
    LedgerAccountConfig,
    CheckBookConfig,
    NormalPaymentConfig,
    openningBalanceConfig,
    BillEntriesConfig,
    InterAccTransferConfig,
    JournalEntryConfig,
    BillPaymnetConfig,
    pettyCashConfig,
    BankDepositConfig,
    BankReconsilationConfig,
    cashTransactionConfig
];


// WEBPACK FOOTER //
// ./src/main/content/accounting/AccountConfigs.js